
  import { Component, Vue, Emit, PropSync, Watch } from "vue-property-decorator";
  import { inject } from "inversify-props";
  import { MealCountDto, ReceivedMealsHardValidator, TemperatureSystem } from "@/models";
  import { IRouterService } from "@/services";
  import moment from "moment";
  import { ObjectHelper, mcDate } from "@/utils";
  import { mcLabels } from '@/view-models';

  @Component
  export default class McReceive extends Vue {
    @inject() routerService!: IRouterService;
    @PropSync("mealCounts", { type: Object }) mealCountsSync!: MealCountDto;

    labels = mcLabels.mealCounts.receive;

    public m = moment;
    private validator = new ReceivedMealsHardValidator();
    dateColor: string = '#46791D';
    warningIcon: boolean = false;

    get deliveryDate() {
      this.futureDate();
      if (!this.mealCountsSync.receivedMeals.mealDeliveryDateTime ||
        this.mealCountsSync.receivedMeals.mealDeliveryDateTime == 'Invalid date'
      ) {
        this.mealCountsSync.receivedMeals.mealDeliveryDateTime = mcDate.utcNow();
      }
      return this.mealCountsSync.receivedMeals.mealDeliveryDateTime;
    }
    set deliveryDate(date) {
      this.mealCountsSync.receivedMeals.mealDeliveryDateTime = date ? mcDate.toUtc(date) : mcDate.utcNow();
    }

    public temperatureKeys: string[] = Object.keys(TemperatureSystem).filter(
      k => typeof TemperatureSystem[k as any] === "number"
    );

    @Emit("input-changed")
    inputChanged() {
      const date = moment.utc().format();
      this.mealCountsSync.versionDateTimeUtc = date;
      this.mealCountsSync.receivedMeals.modifiedDateTimeUtc = date;

      const user = this.$store.state.auth.user;
      this.mealCountsSync.receivedMeals.receivedBy = user.userId;
      this.mealCountsSync.receivedMeals.receivedByFirstName = user.firstName;
      this.mealCountsSync.receivedMeals.receivedByLastName = user.lastName;

      const validations = this.validator.validate(this.mealCountsSync.receivedMeals);
      if (ObjectHelper.keyExists(validations, 'mealDeliveryDateTime')) {
        this.$bvToast.show('dateWarning');
      }
      return this.mealCountsSync.mealTypeId;
    }

    futureDate() {
      if (this.mealCountsSync.receivedMeals.mealDeliveryDateTime > mcDate.utcNow()) {
        this.warningIcon = true;
        this.dateColor = '#ffc107';
      }
      else {
        this.warningIcon = false;
        this.dateColor = '#46791D';
      }
    }
  }
